import { AxiosInstance } from 'axios'
import { useMutation } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import {
  SaveAnnotationAction,
  SaveAnnotationResponse,
} from '@dc-shared-web/hooks/api/annotations/types'

type SaveAnnotationsParams = {
  crunchUUID: string
  action: SaveAnnotationAction
  annotations: any[]
}

const saveAnnotations = async (
  apiClient: AxiosInstance,
  { crunchUUID, action, annotations }: SaveAnnotationsParams
): Promise<SaveAnnotationResponse> => {
  const { data } = await apiClient.post('/ajax/crunches/annotations', {
    crunch: { id: crunchUUID },
    action,
    annotations,
  })

  return data
}

export const useSaveAnnotations = () => {
  const apiClient = useAxiosContext()

  return useMutation((mutationParams: SaveAnnotationsParams) =>
    saveAnnotations(apiClient, mutationParams)
  )
}
